import type { ShortcutRegistryEntry } from "../types/keyboard-shortcuts";

/**
 * Complete keyboard shortcut reference.
 * This is the single source of truth displayed in the ? help dialog.
 */
export const KEYBOARD_SHORTCUT_MAP: ShortcutRegistryEntry[] = [
  // Global
  {
    id: "open-command-palette",
    key: "k",
    modifiers: ["Meta"],
    description: "Open command palette",
    category: "Global",
    display: "\u2318K",
  },
  {
    id: "show-shortcuts",
    key: "?",
    description: "Show keyboard shortcuts",
    category: "Global",
    display: "?",
  },

  // Navigation
  {
    id: "tab-next",
    key: "Tab",
    description: "Move focus to next interactive element",
    category: "Navigation",
    display: "Tab",
  },
  {
    id: "tab-prev",
    key: "Tab",
    modifiers: ["Shift"],
    description: "Move focus to previous interactive element",
    category: "Navigation",
    display: "\u21E7Tab",
  },
  {
    id: "activate",
    key: "Enter",
    description: "Activate focused element",
    category: "Navigation",
    display: "Enter",
  },
  {
    id: "toggle",
    key: " ",
    description: "Toggle focused element (checkbox, switch, accordion)",
    category: "Navigation",
    display: "Space",
  },

  // Overlays
  {
    id: "close-overlay",
    key: "Escape",
    description: "Close topmost overlay",
    category: "Overlays",
    display: "Esc",
  },

  // Components
  {
    id: "arrow-navigate",
    key: "ArrowDown",
    description: "Navigate within component (nav items, results, rows)",
    category: "Components",
    display: "\u2191\u2193",
  },
  {
    id: "list-boundaries",
    key: "Home",
    description: "Jump to first/last item in a list",
    category: "Components",
    display: "Home/End",
  },
];
